<template>
  <div class="whitelist-management">
    <!-- 搜索区域 -->
    <div class="search-container">
      <el-input
        v-model="searchParams.keyword"
        placeholder="输入IP/设备/申请人"
        clearable
        @clear="loadData"
        @keyup.enter.native="loadData"
      />
      <el-button type="primary" @click="loadData">查询</el-button>
      <el-button type="success" @click="handleAdd">申请白名单</el-button>
    </div>

    <!-- 数据表格 -->
    <el-table :data="tableData" border style="width: 100%; margin-top: 20px">
      <el-table-column prop="ipAddress" label="IP地址" width="180" />
      <el-table-column prop="deviceName" label="设备名称" width="150" />
      <el-table-column prop="applicant" label="申请人" width="120" />
      <el-table-column prop="effectiveTime" label="生效时间" width="180">
        <template slot-scope="{ row }">
          {{ formatDate(row.effectiveTime) }}
        </template>
      </el-table-column>
      <el-table-column prop="expiryTime" label="失效时间" width="180">
        <template slot-scope="{ row }">
          {{ formatDate(row.expiryTime) }}
        </template>
      </el-table-column>
      <el-table-column label="操作" width="150">
        <template slot-scope="{ row }">
          <el-button size="small" type="primary" @click="handleEdit(row)">修改</el-button>
          <el-button size="small" type="danger" @click="handleDelete(row.id)">删除</el-button>
        </template>
      </el-table-column>
    </el-table>

    <!-- 分页控件 -->
    <el-pagination
      :current-page="pagination.currentPage"
      :page-size="pagination.pageSize"
      :total="pagination.total"
      layout="total, sizes, prev, pager, next, jumper"
      @size-change="handleSizeChange"
      @current-change="handleCurrentChange"
    />

    <!-- 新增/修改对话框 -->
    <el-dialog :visible.sync="dialogVisible" :title="dialogTitle" width="30%">
      <el-form ref="whitelistForm" :model="currentItem" label-width="100px">
        <el-form-item label="IP地址" prop="ipAddress" v-if="isAddMode">
          <el-input v-model="currentItem.ipAddress" />
        </el-form-item>
        <el-form-item label="设备名称" prop="deviceName" v-if="isAddMode">
          <el-input v-model="currentItem.deviceName" />
        </el-form-item>
        <el-form-item label="申请人" prop="applicant" v-if="isAddMode">
          <el-input v-model="currentItem.applicant" />
        </el-form-item>
        <el-form-item label="生效时间" prop="effectiveTime">
          <el-date-picker
            v-model="currentItem.effectiveTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          />
        </el-form-item>
        <el-form-item label="失效时间" prop="expiryTime">
          <el-date-picker
            v-model="currentItem.expiryTime"
            type="datetime"
            value-format="yyyy-MM-dd HH:mm:ss"
            placeholder="选择日期时间"
          />
        </el-form-item>
      </el-form>
      <template #footer>
        <el-button @click="dialogVisible = false">取消</el-button>
        <el-button type="primary" @click="saveWhitelist">保存</el-button>
      </template>
    </el-dialog>
  </div>
</template>

<script>
import requestTicket from '@/utils/requestTicket';
import {getLocalIP} from "@/utils/ipConfigUtils";

export default {
  name: 'WhitelistManagement',
  data() {
    return {
      // 表格数据
      tableData: [],
      
      // 搜索参数
      searchParams: {
        keyword: ''
      },
      
      // 分页参数
      pagination: {
        currentPage: 1,
        pageSize: 10,
        total: 0
      },
      
      // 对话框状态
      dialogVisible: false,
      dialogTitle: '',
      isAddMode: false,
      currentItem: {
        id: null,
        ipAddress: '',
        deviceName: '',
        applicant: '',
        effectiveTime: '',
        expiryTime: '',
        status: 0
      },
      localIp:  '',
    };
  },
  async mounted() {
    // 初始化加载数据
    this.loadData();
  },
  methods: {
    // 日期格式化
    formatDate(dateStr) {
      if (!dateStr) return '';
      return new Date(dateStr).toLocaleString();
    },
    
    // 加载数据
    async loadData() {
      try {
        
        const res = await requestTicket.post(`/Ticketing/whitelist/page?pageNum=${this.pagination.currentPage}&pageSize=${this.pagination.pageSize}`);
        this.tableData = res.data.records;
        this.pagination.total = res.data.total;
      } catch (error) {
        this.$message.error('数据加载失败');
        console.error(error);
      }
    },
    
    // 分页大小变化
    handleSizeChange(pageSize) {
      this.pagination.pageSize = pageSize;
      this.loadData();
    },
    
    // 当前页变化
    handleCurrentChange(currentPage) {
      this.pagination.currentPage = currentPage;
      this.loadData();
    },
    
    // 处理新增
    async handleAdd() {
      let ip = ''
      await getLocalIP();
      this.localIp = ip
      this.isAddMode = true;
      this.dialogTitle = '新增白名单';
      this.currentItem = {
        ipAddress: this.localIp,
        deviceName: '',
        applicant: '',
        effectiveTime: '',
        expiryTime: '',
        status: 0
      };
      this.dialogVisible = true;
    },
    
    // 处理修改
    handleEdit(row) {
      this.isAddMode = false;
      this.dialogTitle = '修改白名单';
      this.currentItem = { ...row };
      this.dialogVisible = true;
    },
    
    // 保存数据
    async saveWhitelist() {
      try {
        await requestTicket.post('/Ticketing/whitelist/save', this.currentItem);
        this.$message.success('操作成功');
        this.dialogVisible = false;
        this.loadData();
      } catch (error) {
        this.$message.error('操作失败');
        console.error(error);
      }
    },
    
    // 删除数据
    async handleDelete(id) {
      try {
        await requestTicket.delete(`/Ticketing/whitelist/delete/${id}`);
        this.$message.success('删除成功');
        this.loadData();
      } catch (error) {
        this.$message.error('删除失败');
        console.error(error);
      }
    }
  }
};
</script>

<style scoped>
.search-container {
  display: flex;
  gap: 10px;
  margin-bottom: 20px;
}
.whitelist-management {
  padding: 20px;
}
.el-pagination {
  margin-top: 20px;
  justify-content: flex-end;
}
</style>